module.exports = __webpack_public_path__ + "static/img/02.251577b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/02.jpg
// module id = tbKI
// module chunks = 0